<template>
  <div>
    
    <template-breadcrumb />
    <b-container>
      <b-row>
        <b-col xl="10" offset-xl="1">
          <b-form-select v-model="selectedTable" :options="tables" />
        </b-col>
      </b-row>
    </b-container>
    <indica-form
      :table-name="selectedTable"
      :id-to-edit="editId"
      @refresh="refreshData"
    />
    <indica-list
      :refresh="refresh"
      :table-name="selectedTable"
      @edit="setEdit"
    />
  </div>
</template>
<script>
import IndicaForm from "../../../utils/forms/indica-form.vue";
import { Action } from "../../../utils/commons";
import IndicaList from "../../../utils/forms/indica-list";
import { GetTablesNamesForSelector } from "../../../utils/forms/tablesConfiguration";

export default {
  name: "ConfigurationCreateUser",
  components: { IndicaList, IndicaForm },
  data: function () {
    return {
      refresh: 0,
      action: Action,
      
      tables: [],
      selectedTable: "",
      editId: null,
    };
  },
  watch: {
    selectedTable: function () {
      this.editId = null;
    },
  },
  created() {
    this.tables = GetTablesNamesForSelector();
  },
  methods: {
    refreshData() {
      this.refresh++;
      this.editId = null;
    },
    setEdit(id) {
      console.log("setted id" + id);
      this.editId = id;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
